import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getWithExpiry } from '../../../helpers/localStorage'
import { userActions } from '../../../store/users';

import Alerts from '../../../components/multitools/Alerts'
import Preloader from '../../../components/Preloader'

import EditForm from './Form'

const Component = () => {
  const name = 'getMyProfile';

  const dispatch = useDispatch();
  const itemQuery = payload => dispatch(userActions[name](payload))
  const itemRes = useSelector(state => state.users_data[name])
  const status = itemRes?.status ?? ''
  const error = itemRes?.data?.error ?? 'Error'
  const item = itemRes?.data?.item ?? {}
  const items = itemRes?.data?.items ?? []

  useEffect(() => {
      const accessToken = getWithExpiry('accessToken');
      if (accessToken) {
          const payload = {
            data: {},
            token: accessToken,
          }
          itemQuery(payload);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // is loading
  if (['', 'initial', 'loading'].includes(status)) {
    return <Preloader show={true} />
  }

  if (['fail', 'error'].includes(status)) {
    return (
      <div className="mt-3 mb-3">
        <Alerts alerts={error} />
      </div>
    )
  }

  return (
    <EditForm readonly={true} item={item} items={items} />
  );
};

export default Component;
